import React, { useState } from 'react'
import { Modal, ModalBody, ModalHeader, Alert } from 'reactstrap'
import { Form } from 'react-bootstrap'
import { InboxOutlined } from '@ant-design/icons'
import { Upload, message } from "antd"

import { importCityRoutes } from '../services'
import { handleError } from '../../../helpers'

const { Dragger } = Upload

export default function ImportCityRoutesModal({ visible, onClose, reload }) {
    const [loading, setLoading] = useState(false)

	const props = {
        multiple: true,
        customRequest: async ({ file, onError, onSuccess: handleSuccess }) => {
			setLoading(true)
			const values = new FormData()
            values.append('file', file)

            try {
                const response = await importCityRoutes(values)
                handleSuccess(response.data, file)
                message.success('Rutas de entrega importadas exitosamente')
                reload()
                onClose()
            } catch (error) {
                onError(error)
                handleError(error)
				setLoading(false)
            }
        }
    };

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Importar Rutas de Entrega</ModalHeader>
				<ModalBody>
					<Form>
                        <Alert color="info">
                            Para importar masivamente rutas de entrega debe utilizar la plantilla que encuentra el siguiente enlace:
                            <a href="https://docs.google.com/spreadsheets/d/1Bzq3pY53TJMrpgwp32K4sa10dRYlLTBr2U-HCbbj4QM/edit?usp=sharing" target="_blank" rel="noopener noreferrer">
                                Plantilla de Importación de Rutas de Entrega
                            </a>
                            <br />
                            <br />
                            Una vez descargada la plantilla, debe completar los campos correspondientes y subir el archivo CSV.
                            <br />
                            <br />
                            Sí ya existe una ruta de entrega con la misma ciudad, se actualizará la información que diligencie. Si no existe, se creará una nueva ruta de entrega. Las tarifas se actualizarán según la plantilla, se eliminaran las tarifas existentes.
                            <br />
                            <br />
                            Sí la ruta en la plantilla no tiene tarifas, no se eliminarán las tarifas existentes.
                        </Alert>
						<Form.Group>
							<Form.Label>Archivo CSV</Form.Label>
							<Dragger {...props} disabled={loading}>
								<p className="ant-upload-drag-icon"><InboxOutlined /></p>
								<p className="ant-upload-text">Haga clic o arrastre el adjunto</p>
								<p className="ant-upload-hint">Solo se permite adjuntar archivos menores a 5MB.</p>
							</Dragger>
						</Form.Group>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}